export const authToken = (state) => state.authToken;
export const loggedIn = (state) => state.authToken !== null;
export const getCompany = (state) => state.company;
